import { getAuthUser } from '@/utils/auth'
import OrganizationsScreen from '@features/organizations/screens/OrganizationsScreen'
import { Layout } from '@layouts/Layout'
import type { GetServerSidePropsContext } from 'next'
import * as React from 'react'
import type { NextPageWithLayout } from 'types/next'

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const user = await getAuthUser(context)

  return {
    props: {
      user,
    },
  }
}

const OrganizationsPage: NextPageWithLayout = OrganizationsScreen
OrganizationsPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout user={page.props.user}>{page}</Layout>
}
export default OrganizationsPage
